import * as React from 'react';

import Modal from 'src/components/common/Modal';

import { isMobile } from 'src/utils/responsiveHelpers';
import './FinalWarehouseCheck.scss';

interface IFinalWarehouseCheckProps {
  onClose?: () => void;
  handleAddToCart(): void;
  handleChangeWarehouse(): void;
  t?: any;
}

interface IFinalWarehouseCheckState {
  isMobile: boolean;
}

class FinalWarehouseCheck extends React.Component<
  IFinalWarehouseCheckProps,
  IFinalWarehouseCheckState
> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile()
    };
  }

  private onChangeWarehouse = (e: any) => {
    this.props.onClose();
    this.props.handleChangeWarehouse();
  };

  private onAddToCart = (e: any) => {
    this.props.onClose();
    this.props.handleAddToCart();
  };

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  private renderMessage = () => {
    const { t } = this.props;
    return (
      <div className="rp-final-warehouse-check--content">
        <span
          onClick={e => this.props.onClose()}
          className="rpds-close rp-final-warehouse-check--content--close-modal-icon"
        />
        <p className="rp-final-warehouse-check--content-text">
          {t('common.notEnoughQuantity')} {t('common.chooseDifferentWarehouse')}
        </p>
        <div className="rp-final-warehouse-check--buttons">
          <button onClick={this.onChangeWarehouse} className="primary-button">
            {t('common.change')}
          </button>
          <button className="secondary-button" onClick={this.onAddToCart}>
            {t('common.continueActionTxt')}
          </button>
        </div>
      </div>
    );
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-final-warehouse-check">
        {this.state.isMobile ? (
          <div className="rp-final-warehouse-check--mobile">
            <div
              onClick={e => this.props.onClose()}
              className="rp-final-warehouse-check--mobile-cancel"
            >
              <span className="rpds-close cancel-icon" />
              {t('common.cancel')}
            </div>
            {this.renderMessage()}
          </div>
        ) : (
          <Modal handleCloseModal={() => this.props.onClose()}>
            {this.renderMessage()}
          </Modal>
        )}
      </div>
    );
  }
}

export default FinalWarehouseCheck;
